export default __webpack_public_path__ + "static/media/location_icon2.179bcdf3.svg";